module.exports = __webpack_public_path__ + "img/Weapon_176.b3072e6c.png";